// TRIAL — gym-card form
export default function Trial() {
  return (
    <div className="bg-[#0A0A0A] text-white">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#F2C500]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F2C500] mb-3">▶ Section 04 / Free trial</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">One session, <span className="italic text-[#F2C500]">no string attached</span>.</h1>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 py-12 grid lg:grid-cols-[1fr_1.5fr] gap-10">
        <aside>
          <div className="border-l-4 border-[#F2C500] pl-6">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] mb-2">▶ What to expect</p>
            <ul className="space-y-3 mt-3 text-base text-white/85">
              <li className="flex gap-3"><span className="text-[#F2C500] font-bold">01.</span>Twenty-minute movement screen with a coach</li>
              <li className="flex gap-3"><span className="text-[#F2C500] font-bold">02.</span>Forty-minute coached strength session</li>
              <li className="flex gap-3"><span className="text-[#F2C500] font-bold">03.</span>Programming chat & goal-setting · 15 min</li>
            </ul>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/45 mt-6 leading-relaxed">No sales pitch. If we are not the right gym, we will tell you which one is.</p>
          </div>
        </aside>
        <form className="bg-[#1A1A1A] border border-white/15 p-8 lg:p-10 space-y-6" onSubmit={(e) => e.preventDefault()}>
          <div className="border-b-2 border-[#F2C500] pb-3 flex items-baseline justify-between">
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500]">▶ Trial Session Booking</span>
            <span className="font-mono text-[10px] text-white/45">FREE</span>
          </div>
          <Field label="Name" testId="fit-trial-name" />
          <div className="grid sm:grid-cols-2 gap-5"><Field label="Email" type="email" testId="fit-trial-email" /><Field label="Phone" type="tel" testId="fit-trial-tel" /></div>
          <SelectField label="Training experience" testId="fit-trial-exp" options={['Beginner · &lt;1 yr', 'Intermediate · 1–3 yrs', 'Advanced · 3+ yrs', 'Returning after a break']} />
          <SelectField label="Primary goal" testId="fit-trial-goal" options={['Get stronger', 'Build muscle', 'Olympic lifting / technique', 'Conditioning · sport prep', 'Lose body fat', 'General fitness']} />
          <Field label="Preferred date" type="date" testId="fit-trial-date" />
          <button type="button" data-testid="fit-trial-submit" className="bg-[#F2C500] text-[#0A0A0A] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-white transition-colors w-full">Book free session →</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-[#0A0A0A] border border-white/15 px-4 py-3 outline-none focus:border-[#F2C500] text-base text-white" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-[#0A0A0A] border border-white/15 px-4 py-3 outline-none focus:border-[#F2C500] text-base text-white">{options.map(o => <option key={o} dangerouslySetInnerHTML={{ __html: o }} />)}</select>
    </div>
  );
}
